// Author: Kevin Thomas : XKO
// Date: 02/11/04
// JOB 22124

// This file contains barcode check-digit javascript functions for Full ASCII

function ccd_GetFullASCIIcode(chrCurr) {
  // Check if chrCurr is undefined or an empty string
  if (typeof chrCurr !== 'string' || chrCurr.length === 0) {
    // Handle the case where chrCurr is undefined or an empty string
    // For example, you could return null, throw an error, or handle it in another way
    return null;
  }

  var intCode, intCharCode;

  intCharCode = chrCurr.charCodeAt(0);

  if (chrCurr >= "0" && chrCurr <= "9")
    intCode = intCharCode - "0".charCodeAt(0);
  else if (chrCurr >= "A" && chrCurr <= "Z")
    intCode = intCharCode - "A".charCodeAt(0) + 10;
  else if (chrCurr == "-") intCode = 36;
  else if (chrCurr == ".") intCode = 37;
  else if (chrCurr == " ") intCode = 38;
  else if (chrCurr == "$") intCode = 39;
  else if (chrCurr == "/") intCode = 40;
  else if (chrCurr == "+") intCode = 41; // Handle special character "+"
  else if (chrCurr == "%") intCode = 42;
  else if (chrCurr == "($)") intCode = 43;
  else if (chrCurr == "(%)") intCode = 44;
  else if (chrCurr == "(/)") intCode = 45;
  else if (chrCurr == "(+)") intCode = 46;

  return intCode;
}

export default ccd_GetFullASCIIcode;
